import React from "react";
// import VideoText2021 from "./VideoText/VideoText2021";
// import VideoText2022 from "./VideoText/VideoText2022";
// import VideoText2023 from "./VideoText/VideoText2023";
// import VideoText2024 from "./VideoText/VideoText2024";
import VideoText2025 from "./VideoText/VideoText2025";
import Video from "./video/Video";
import { IVideoDetail } from "../../../models/Video.interface";

function VideoList(props: {
  title: string;
  // category: number;
  setVideoDetailDialogOpen: React.Dispatch<React.SetStateAction<boolean>>;
  isVideoDetailDialogOpen: boolean;
}): JSX.Element | null {
  // const [videoList, setVideoList] = useState<IVideoDetail[]>([]);
  const videoList = VideoText2025;
  const {
    title,
    // category,
    isVideoDetailDialogOpen,
    setVideoDetailDialogOpen,
  } = props;

  // const { data, error, loading } = useQuery<IVideoList>(GET_VIDEO_LIST, {
  //   variables: {
  //     category: category,
  //   },
  // });

  // 주의: 2021년 이후의 데이터는 DB에서 들고오지 않고 텍스트로 하드코딩한 데이터를 부른다 (매번 운영기DB 기안을 올릴 수는 없어서)
  // useEffect(() => {
  //   switch (category) {
  //     case 2021:
  //       setVideoList(VideoText2021);
  //       break;

  //     case 2022:
  //       setVideoList(VideoText2022);
  //       break;

  //     case 2023:
  //       setVideoList(VideoText2023);
  //       break;

  //     default:
  //       setVideoList(VideoText2023);
  //       break;
  //   }
  // }, [category]);

  return (
    <>
      <div className="sec_title">
        <h3 className="tit">
          {title}
          <em>{videoList.length}</em>
        </h3>
      </div>

      {/* 주의: 2021년 이후의 데이터는 DB에서 들고오지 않고 텍스트로 하드코딩한 데이터를 부른다 (매번 운영기DB 기안을 올릴 수는 없어서) */}
      <div className="sec_content">
        <ul className="video_list">
          {videoList.map((video: IVideoDetail, index: number) => (
            <Video
              key={index}
              videoDetail={video}
              setOpen={setVideoDetailDialogOpen}
              isVideoDetailDialogOpen={isVideoDetailDialogOpen}
            />
          ))}
        </ul>
      </div>
    </>
  );
}

export default VideoList;
